<template>
  <div>
    <Spin
      fix
      v-show="
        isRechargeInfo ||
          isRecentRechargeRecord ||
          isDeviceStatusRecent ||
          isExceptionRecent ||
          isCommitSpin ||
          isSpinShow
      "
    >
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Tabs ref="tabs">
      <TabPane label="充值" icon="logo-bitcoin" style="font-size:12pt">
        <!--<rechargeExpand ref="rechargeExpand"></rechargeExpand>收据-->
        <Row style="background:#fff;padding:10px">
          <i-col span="12">
            <Card>
              <p slot="title">
                <Icon type="ios-contact" size="21" />
                用户信息
              </p>
              <Row>
                <i-col span="24">
                  用户姓名 : {{ rechargeBaseInfo.customerName }}
                </i-col>
                <Row> </Row>
                <i-col span="24">
                  手机号 : {{ rechargeBaseInfo.customerPhone }}
                </i-col>
              </Row>
              <Row>
                <i-col span="24">
                  身份证号 : {{ rechargeBaseInfo.customerIdcard }}
                </i-col>
              </Row>
              <Row>
                <i-col span="24">
                  地址 : {{ rechargeBaseInfo.addressLowestLevelAddressIds }}
                </i-col>
              </Row>
            </Card>
          </i-col>

          <i-col span="11" offset="1">
            <Row>
              <Card>
                <p slot="title">
                  <Icon type="ios-pulse" size="20" />
                  设备状态
                </p>
                {{ deviceStatusPresent }}
              </Card>
            </Row>
            <Row style="padding:20px 0px 0px 0px;">
              <Card>
                <p slot="title">
                  <Icon type="md-close-circle" size="20" />
                  报警信息
                </p>
                {{ exceptionPresent }}
              </Card>
            </Row>
          </i-col>
        </Row>
        <Row style="background:#fff;padding:10px">
          <i-col span="12">
            <Card v-if="isFlow">
              <p slot="title">
                <Icon type="logo-yen" size="16" />
                充值信息
              </p>
              <Row>
                <i-col span="23">
                  <Row>
                    <i-col span="8" style="text-align: right;">
                      工况流量 ：
                    </i-col>
                    <i-col span="8" style="text-align: center;">
                      <InputNumber
                        v-model="workingFlowRecharge"
                        :max="10000"
                        :min="0"
                        :step="1"
                        size="small"
                        :precision="0"
                        @on-change="onWorkingFlowRechargeChange"
                      >
                      </InputNumber>
                    </i-col>
                    <i-col span="4"> m<sup>3</sup> </i-col>
                  </Row>

                  <Row>
                    <i-col span="8" style="text-align: right;">
                      缴费金额 ：
                    </i-col>
                    <i-col span="8" style="text-align: center;">
                      {{ workingFlowRechargeMoney }}
                    </i-col>
                    <i-col span="4">
                      元
                    </i-col>
                  </Row>
                  <Row>
                    <i-col span="8" style="text-align: right;">
                      当前气价 ：
                    </i-col>
                    <i-col span="8" style="text-align: center;">
                      {{ workingFlowRankPricePresent }}
                    </i-col>
                    <i-col span="4">
                      元
                    </i-col>
                  </Row>
                  <Row>
                    <i-col span="8" style="text-align: right;">
                      当前阶梯剩余气量 ：
                    </i-col>
                    <i-col span="8" style="text-align: center;">
                      {{ workingFlowRankRemain }}
                    </i-col>
                    <i-col span="4"> m<sup>3</sup> </i-col>
                  </Row>
                </i-col>
              </Row>
            </Card>
            <Card v-if="!isFlow">
              <p slot="title">
                <Icon type="logo-yen" size="16" />
                充值信息
              </p>
              <Row>
                <i-col span="23">
                  <Row>
                    <i-col span="8" style="text-align: right;">
                      工况金额 ：
                    </i-col>
                    <i-col span="8" style="text-align: center;">
                      <InputNumber
                        v-model="workingMoneyRecharge"
                        :max="10000"
                        :min="0"
                        :step="1"
                        size="small"
                        :precision="0"
                      >
                      </InputNumber>
                    </i-col>
                    <i-col span="4">
                      元
                    </i-col>
                  </Row>
                </i-col>
              </Row>
            </Card>
          </i-col>
          <i-col span="11" offset="1">
            <Card>
              <p slot="title">
                <Icon type="md-trending-up" size="25" />
                阶梯气价
              </p>
              <Span
                v-if="isMainOverDue && !isStandbyOverDue"
                style="color: #FF0000;"
                >当前使用备用阶梯</Span
              >
              <Span v-if="Object.keys(ladderPriceRecent.paras) == 0"
                >当前未设置阶梯气价或者阶梯气价超期</Span
              >
              <Span v-else v-for="index in [1, 2, 3, 4, 5, 6]" :key="index">
                第{{ index }}阶梯{{
                  ladderPriceRecent.paras["mainPlanLadder" + index + "Flow"]
                }}立方米，价格{{
                  ladderPriceRecent.paras["mainPlanLadder" + index + "Price"] /
                    100
                }}元/m
                <sup>3</sup>
                <br />
              </Span>
              <br />
              <Button type="primary" @click="showLadderPriceList"
                >修改阶梯气价</Button
              >
            </Card>
          </i-col>
        </Row>
      </TabPane>
      <TabPane label="充值历史" icon="md-albums">
        <Table
          :width="width"
          border
          stripe
          highlight-row
          ref="currentRowTable"
          :columns="columnsRechargeRecord"
          :data="dataRechargeRecord"
        ></Table>
        <Page
          :current="page"
          :total="dataCount"
          :page-size="pageAmount"
          show-sizer
          show-total
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        ></Page>
      </TabPane>
    </Tabs>
    <Modal
      title="下发阶梯气价"
      v-model="modalLadderPrice"
      :mask-closable="false"
      :width="90"
      @on-ok="ok"
      ok-text="下发阶梯气价"
    >
      <div>
        <Spin fix v-show="isSpinShow">
          <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <Table border stripe :columns="columns1" :data="showData"></Table>
        <Page
          :current="currentPage"
          :total="ladderCount"
          :page-size="pageSize"
          show-sizer
          show-total
          @on-change="changeLadderPricePage"
          @on-page-size-change="changeLadderPricePageSize"
        ></Page>
      </div>
    </Modal>
  </div>
</template>

<script>
import rechargeExpand from "./RechargeExpand.vue";
export default {
  mounted() {},
  data() {
    return {
      //data:[],
      isSpinShow: false,
      isCommitSpin: false,
      columns1: [
        {
          title: " ",
          width: 60,
          key: "checkBox",
          render: (h, params) => {
            return h("Checkbox", {
              props: {
                value: params.row.checkBox,
              },
              on: {
                "on-change": (val) => {
                  this.showData.forEach((items) => {
                    //先取消所有对象的勾选，checkBox设置为false
                    this.$set(items, "checkBox", false);
                  });
                  this.showData[params.index].checkBox = val;
                  if (val) {
                    this.selectIndex = params.index;
                  } else {
                    this.selectIndex = -1;
                  }
                },
              },
            });
          },
        },
        {
          title: "阶梯气价名称",
          key: "ladderPriceName",
        },
        {
          title: "用气类型",
          key: "gasTypeName",
        },
        {
          title: "主阶梯气价",
          key: "mainPlan",
          tooltip: true,
        },
        {
          title: "备用阶梯气价",
          key: "standbyPlan",
          tooltip: true,
        },
        {
          title: "管辖机构",
          key: "governingBodyName",
        },
      ],
      showData: [],
      ladderCount: 0,
      currentPage: 1,
      pageSize: 10,
      dataForDown: [],
      modalLadderPrice: false,
      isRechargeInfo: false,
      isRecentRechargeRecord: false,
      isDeviceStatusRecent: false,
      isExceptionRecent: false,
      width: document.body.clientWidth * 0.8,
      deviceTemp: {},
      rechargeBaseInfo: {},
      ladderPriceRecent: {
        paras: {},
      },
      isTrueLadderPrice: true,
      ladderPriceFlow: [],
      ladderPriceMoney: [],
      isFlow: true,
      workingFlowRecharge: 0, //工况流量
      workingFlowRechargeMoney: 0.0, //工况流量缴费金额
      workingFlowRankPricePresent: 0.0, //工况流量当前气价
      workingFlowRankRemain: 0.0, //工况流量当前阶梯剩余气量
      deviceStatusCommand: {}, //设备状态命令
      exceptionCommand: {}, //报警信息命令
      ladderPriceCommand: {}, //阶梯气价指令
      deviceStatus: {}, //设备状态参数
      deviceStatusPresent: "", //设备状态显示
      exceptionPresent: "",
      doRechargeData: {}, //下发充值数据
      totalRecordFlow: 0.0, //历史充值合计流量
      totalRecordMoney: 0.0, //历史充值合计钱
      workingMoneyRecharge: 0, //工况金额
      columnsRechargeRecord: [
        {
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "用户",
          key: "recordRechargeCustomerName",
        },
        {
          title: "缴费金额（元）",
          key: "recordRechargePrice",
        },
        {
          title: "充值气量（m³）",
          key: "recordRechargeFlow",
        },
        {
          title: "缴费时间",
          key: "recordRechargeDate",
          render: function(h, params) {
            return h(
              "div",
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(this.row.recordRechargeDate)
              )
            ); /*这里的this.row能够获取当前行的数据*/
          },
        },
        {
          title: "主阶梯气价",
          key: "mainPlan",
          tooltip: true,
        },
        {
          title: "备用阶梯气价",
          key: "standbyPlan",
          tooltip: true,
        },
        {
          title: "营业员",
          key: "recordRechargePersonnelName",
        },
      ],
      dataRechargeRecord: [],
      page: 1,
      pageAmount: 10,
      dataCount: 0,
      isMainOverDue: false,
      isStandbyOverDue: false,
    };
  },
  methods: {
    changeLadderPricePage(index) {
      this.currentPage = index;
      this.showLadderPriceList();
    },
    changeLadderPricePageSize(size) {
      this.pageSize = size;
      this.showLadderPriceList();
    },
    showLadderPriceList() {
      let that = this;
      that.modalLadderPrice = true;
      if (
        that.rechargeBaseInfo.addressGoverningBody &&
        that.rechargeBaseInfo.meterGasType
      ) {
        that.selectIndex = -1;
        that.isSpinShow = true;
        $.ajax({
          url:
            "/api/ladderPrice/selectLadderPriceMeterGasType?page=" +
            this.currentPage +
            "&pageAmount=" +
            this.pageSize,
          contentType: "application/json",
          type: "post",
          data: JSON.stringify({
            ladderGoverningId: that.rechargeBaseInfo.addressGoverningBody,
            contrastGasTypeId: that.rechargeBaseInfo.meterGasType,
          }),
          dataType: "json",
          success: function(data) {
            if (data.errorCode != 0) {
              that.$Notice.error({
                title: "异常",
                desc: data.errorInfo,
              });
              return;
            }
            that.showData = data.body.resultList.map((param) => {
              param["ladderData"] = JSON.parse(param.ladderDataString) || {};
              let mainPlan = "";
              mainPlan +=
                "开始时间：" +
                global.dateFtt(
                  "yyyy-MM-dd hh:mm:ss",
                  new Date(param.ladderData.mainPlanStartTime)
                ) +
                "\n";
              mainPlan +=
                "结束时间：" +
                global.dateFtt(
                  "yyyy-MM-dd hh:mm:ss",
                  new Date(param.ladderData.mainPlanEndTime)
                ) +
                "\n";
              mainPlan +=
                "结算类型：" +
                global.ladderPriceSettleType[
                  param.ladderData.mainPlanSettleType
                ];
              if (
                param.ladderData.mainPlanSettleType != 0 &&
                param.ladderData.mainPlanSettleType != 4
              ) {
                mainPlan +=
                  "\n结算周期：" + param.ladderData.mainPlanSettleParameter;
              }
              for (var i = 1; i <= 6; i++) {
                mainPlan +=
                  "\n" +
                  "第" +
                  i +
                  "阶梯共" +
                  param.ladderData["mainPlanLadder" + i + "Flow"] +
                  "m³,价格:" +
                  param.ladderData["mainPlanLadder" + i + "Price"] / 100 +
                  "元/m³";
              }
              param["mainPlan"] = mainPlan;
              let standbyPlan = "";
              standbyPlan +=
                "开始时间：" +
                global.dateFtt(
                  "yyyy-MM-dd hh:mm:ss",
                  new Date(param.ladderData.standbyPlanStartTime)
                ) +
                "\n";
              standbyPlan +=
                "结束时间：" +
                global.dateFtt(
                  "yyyy-MM-dd hh:mm:ss",
                  new Date(param.ladderData.standbyPlanEndTime)
                ) +
                "\n";
              standbyPlan +=
                "结算类型：" +
                global.ladderPriceSettleType[
                  param.ladderData.standbyPlanSettleType
                ];
              if (
                param.ladderData.standbyPlanSettleType != 0 &&
                param.ladderData.standbyPlanSettleType != 4
              ) {
                standbyPlan +=
                  "\n结算周期：" + param.ladderData.standbyPlanSettleParameter;
              }
              for (var i = 1; i <= 6; i++) {
                standbyPlan +=
                  "\n" +
                  "第" +
                  i +
                  "阶梯共" +
                  param.ladderData["standbyPlanLadder" + i + "Flow"] +
                  "m³,价格:" +
                  param.ladderData["standbyPlanLadder" + i + "Price"] / 100 +
                  "元/m³";
              }
              param["standbyPlan"] = standbyPlan;
              return param;
            });
            that.ladderCount = data.body.amount;
          },
          error: function(textStatus) {
            that.$Notice.error({
              title: "异常",
              desc: "接口请求异常",
            });
          },
          complete: function() {
            that.isSpinShow = false;
          },
        });
      }
    },
    ok() {
      if (
        this.selectIndex != -1 &&
        this.showData[this.selectIndex] != undefined
      ) {
        var that = this;
        var ladderPriceModel = {};
        ladderPriceModel["ladderPriceData"] = JSON.parse(
          JSON.stringify(this.showData[this.selectIndex].ladderData)
        );
        for (var i = 1; i <= 6; i++) {
          ladderPriceModel["ladderPriceData"]["mainPlanLadder" + i + "Price"] =
            ladderPriceModel["ladderPriceData"][
              "mainPlanLadder" + i + "Price"
            ] >> 0;
          ladderPriceModel["ladderPriceData"][
            "standbyPlanLadder" + i + "Price"
          ] =
            ladderPriceModel["ladderPriceData"][
              "standbyPlanLadder" + i + "Price"
            ] >> 0;
        }
        ladderPriceModel["meterId"] = this.deviceTemp.meterId;
        that.isSpinShow = true;
        //下发阶梯气价
        $.ajax({
          url: "/api/recharge/downLadderPrice",
          contentType: "application/json",
          type: "post",
          data: JSON.stringify(ladderPriceModel),
          dataType: "json",
          success: function(data) {
            if (data.errorCode != 0) {
              that.$Notice.error({
                title: "异常",
                desc: data.errorInfo,
              });
              return;
            }
            that.getRechargeBaseInfo(that.deviceTemp.meterId);
            that.$Notice.success({
              title: "成功",
              desc: "下发阶梯气价成功",
            });
          },
          error: function(textStatus) {
            that.$Notice.error({
              title: "异常",
              desc: "接口请求异常",
            });
          },
          complete: function() {
            that.isSpinShow = false;
          },
        });
        this.modalLadderPrice = false;
      } else {
        this.$Notice.warning({
          title: "异常",
          desc: "没有选择任何数据",
        });
      }
    },
    overDue() {
      let that = this;
      if (
        new Date().getTime() <
          new Date().getTime(that.ladderPriceRecent.paras.mainPlanStartTime) ||
        new Date().getTime(that.ladderPriceRecent.paras.mainPlanEndTime) <
          new Date().getTime()
      ) {
        that.isMainOverDue = true;
        if (
          new Date().getTime() <
            new Date().getTime(
              that.ladderPriceRecent.paras.standbyPlanStartTime
            ) ||
          new Date().getTime(that.ladderPriceRecent.paras.standbyPlanEndTime) <
            new Date().getTime()
        ) {
          that.isStandbyOverDue = true;
          that.ladderPriceRecent = {
            paras: {},
          };
        } else {
          that.ladderPriceRecent.paras.mainPlanStartTime =
            that.ladderPriceRecent.paras.standbyPlanStartTime;
          that.ladderPriceRecent.paras.mainPlanEndTime =
            that.ladderPriceRecent.paras.standbyPlanEndTime;
          that.ladderPriceRecent.paras.mainPlanSettleType =
            that.ladderPriceRecent.paras.standbyPlanSettleType;
          that.ladderPriceRecent.paras.mainPlanSettleParameter =
            that.ladderPriceRecent.paras.standbyPlanSettleParameter;
          for (let i = 1; i <= 6; i++) {
            that.ladderPriceRecent.paras["mainPlanLadder" + i + "Flow"] =
              that.ladderPriceRecent.paras["standbyPlanLadder" + i + "Flow"];
            that.ladderPriceRecent.paras["mainPlanLadder" + i + "Price"] =
              that.ladderPriceRecent.paras["standbyPlanLadder" + i + "Price"];
          }
        }
      }
    },
    getRechargeBaseInfo(param) {
      var that = this;
      this.deviceTemp["meterId"] = param;
      that.isRechargeInfo = true;
      that.workingFlowRecharge = 0; //工况流量
      that.workingFlowRechargeMoney = 0.0; //工况流量缴费金额
      that.workingMoneyRecharge = 0; //工况金额
      that.workingFlowRankPricePresent = 0;
      that.rechargeBaseInfo = {};
      that.ladderPriceRecent = {
        paras: {},
      };
      //请求设备基础数据
      $.ajax({
        url: "/api/recharge/getRechargeBaseInfo",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.deviceTemp),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            return;
          }
          that.rechargeBaseInfo = data.body;
          if (data.body.command) {
            that.ladderPriceRecent = JSON.parse(
              data.body.command.commandContent
            );
          } else {
            that.ladderPriceRecent = {
              paras: {},
            };
          }
          that.overDue();
          if (data.body.meterTypePayType.indexOf("流量") != -1) {
            that.isFlow = true;
            if (!that.isStandbyOverDue && data.body.command) {
              var recordRecent = {};
              recordRecent["recordRechargeMeterId"] =
                that.rechargeBaseInfo.meterId;
              console.log(that.ladderPriceRecent.paras);
              if (
                that.ladderPriceRecent.paras.mainPlanSettleType == 0 ||
                that.ladderPriceRecent.paras.mainPlanSettleType == 4
              ) {
                recordRecent["recordRechargeDateMin"] = new Date(
                  that.ladderPriceRecent.paras.mainPlanStartTime
                ).getTime();
              } else {
                let days = 0;
                if (that.ladderPriceRecent.paras.mainPlanSettleType == 1) {
                  days = 30;
                } else if (
                  that.ladderPriceRecent.paras.mainPlanSettleType == 2
                ) {
                  days = 90;
                } else if (
                  that.ladderPriceRecent.paras.mainPlanSettleType == 3
                ) {
                  days = 365;
                } else if (
                  that.ladderPriceRecent.paras.mainPlanSettleType == 5
                ) {
                  days = that.ladderPriceRecent.paras.mainPlanSettleParameter;
                }
                let count =
                  (new Date().getTime() -
                    new Date().getTime(
                      that.ladderPriceRecent.paras.mainPlanStartTime
                    )) /
                  (days * 24 * 60 * 60 * 1000);
                count = count >> 0;
                recordRecent["recordRechargeDateMin"] =
                  new Date(
                    that.ladderPriceRecent.paras.mainPlanStartTime
                  ).getTime() +
                  count * (days * 24 * 60 * 60 * 1000);
              }
              if (
                data.body.command.commandTimestamp >
                recordRecent["recordRechargeDateMin"]
              ) {
                recordRecent["recordRechargeDateMin"] =
                  data.body.command.commandTimestamp;
              }
              that.isRecentRechargeRecord = true;
              //获得上次充值信息
              $.ajax({
                url: "/api/recharge/getRecentRechargeRecord",
                contentType: "application/json",
                type: "post",
                data: JSON.stringify(recordRecent),
                dataType: "json",
                success: function(data) {
                  if (data.errorCode != 0) {
                    that.$Notice.error({
                      title: "异常",
                      desc: data.errorInfo,
                    });
                    that.isRecentRechargeRecord = false;
                    return;
                  }
                  if (data.body != null) {
                    that.workingFlowRankPricePresent =
                      data.body.recordRechargePresentLadderPrice;
                    that.workingFlowRankRemain =
                      data.body.recordRechargePresentLadderFlowRemain;
                    that.totalRecordFlow = data.body.totalFlow;
                    that.totalRecordMoney = data.body.totalMoney;
                  } else {
                    that.workingFlowRankPricePresent = 0;
                    that.workingFlowRankRemain = 0;
                    that.totalRecordFlow = 0;
                    that.totalRecordMoney = 0;
                  }
                  that.isRecentRechargeRecord = false;
                },
                error: function(textStatus) {
                  that.$Notice.error({
                    title: "异常",
                    desc: "接口请求异常",
                  });
                },
              });
            }
          } else if (data.body.meterTypePayType.indexOf("金额") != -1) {
            that.isFlow = false;
          }
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
        complete: function() {
          that.isRechargeInfo = false;
        },
      });
      //请求设备状态
      this.deviceStatusCommand["commandType"] = "0x83";
      this.deviceStatusCommand["commandDeviceId"] = param;
      that.isDeviceStatusRecent = true;
      $.ajax({
        url: "/api/instructions/getInstructionRecent",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.deviceStatusCommand),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            that.isDeviceStatusRecent = false;
            return;
          }
          //处理设备状态
          if (data.body != null) {
            that.deviceStatus = JSON.parse(data.body.commandContent);
            if (
              that.deviceStatus.service.data.isValveBan == "true" &&
              that.deviceStatus.service.data.isValveClosed == "true"
            ) {
              that.deviceStatusPresent = "表阀禁用/表阀关闭";
            } else if (
              that.deviceStatus.service.data.isValveBan == "true" &&
              that.deviceStatus.service.data.isValveClosed == "false"
            ) {
              that.deviceStatusPresent = "表阀禁用";
            } else if (
              that.deviceStatus.service.data.isValveBan == "false" &&
              that.deviceStatus.service.data.isValveClosed == "true"
            ) {
              that.deviceStatusPresent = "表阀关闭";
            } else if (
              that.deviceStatus.service.data.isValveBan == "false" &&
              that.deviceStatus.service.data.isValveClosed == "false"
            ) {
              that.deviceStatusPresent = "表阀正常";
            }
          } else {
            that.deviceStatusPresent = "表阀正常";
          }
          that.isDeviceStatusRecent = false;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
      });
      //请求报警信息
      this.exceptionCommand["commandType"] = "0x81";
      this.exceptionCommand["commandDeviceId"] = param;
      that.isExceptionRecent = true;
      $.ajax({
        url: "/api/instructions/getInstructionRecent",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.exceptionCommand),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            that.isExceptionRecent = false;
            return;
          }
          //处理报警信息
          if (data.body != null) {
            let exception = JSON.parse(data.body.commandContent);
            //十进制报警字段转2进制
            let exceptionNumber2 = parseInt(
              exception.service.data.errorFlags
            ).toString(2); //2进制补零
            let exceptions = (Array(32).join("0") + exceptionNumber2).slice(
              -32
            );
            let exceptionList = exceptions.split(""); //2进制数组
            exceptionList.reverse().forEach((item, index) => {
              if (global.errorMsgParam[index] && item == 1) {
                that.exceptionPresent =
                  that.exceptionPresent == ""
                    ? global.errorMsgParam[index].name
                    : that.exceptionPresent +
                      "," +
                      global.errorMsgParam[index].name;
              }
            });
            if (that.exceptionPresent == "") {
              that.exceptionPresent = "表具正常";
            }
          } else {
            that.exceptionPresent = "无报警信息";
          }
          that.isExceptionRecent = false;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
      });
    },
    changePage(index) {
      this.page = index;
      this.getRecordPage(this.deviceTemp.meterId);
    },
    changePageSize(size) {
      this.pageAmount = size;
      this.getRecordPage(this.deviceTemp.meterId);
    },
    getRecordPage(param) {
      var that = this;
      var recordModel = {};
      recordModel["recordRechargeMeterId"] = param;
      //请求设备基础数据
      $.ajax({
        url:
          "/api/recharge/getRechargeRecordList?page=" +
          this.page +
          "&pageAmount=" +
          this.pageAmount,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(recordModel),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            return;
          }
          that.dataRechargeRecord = data.body.resultList.map((param) => {
            param["ladderData"] = JSON.parse(
              param.recordRechargeLadderPriceCopy
            ).paras;
            let mainPlan = "";
            mainPlan +=
              "开始时间：" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(param.ladderData.mainPlanStartTime)
              ) +
              "\n";
            mainPlan +=
              "结束时间：" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(param.ladderData.mainPlanEndTime)
              ) +
              "\n";
            mainPlan +=
              "结算类型：" +
              global.ladderPriceSettleType[param.ladderData.mainPlanSettleType];
            if (
              param.ladderData.mainPlanSettleType != 0 &&
              param.ladderData.mainPlanSettleType != 4
            ) {
              mainPlan +=
                "\n结算周期：" + param.ladderData.mainPlanSettleParameter;
            }
            for (var i = 1; i <= 6; i++) {
              mainPlan +=
                "\n" +
                "第" +
                i +
                "阶梯共" +
                param.ladderData["mainPlanLadder" + i + "Flow"] +
                "m³,价格:" +
                param.ladderData["mainPlanLadder" + i + "Price"] / 100 +
                "元/m³";
            }
            param["mainPlan"] = mainPlan;
            let standbyPlan = "";
            standbyPlan +=
              "开始时间：" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(param.ladderData.standbyPlanStartTime)
              ) +
              "\n";
            standbyPlan +=
              "结束时间：" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(param.ladderData.standbyPlanEndTime)
              ) +
              "\n";
            standbyPlan +=
              "结算类型：" +
              global.ladderPriceSettleType[
                param.ladderData.standbyPlanSettleType
              ];
            if (
              param.ladderData.standbyPlanSettleType != 0 &&
              param.ladderData.standbyPlanSettleType != 4
            ) {
              standbyPlan +=
                "\n结算周期：" + param.ladderData.standbyPlanSettleParameter;
            }
            for (var i = 1; i <= 6; i++) {
              standbyPlan +=
                "\n" +
                "第" +
                i +
                "阶梯共" +
                param.ladderData["standbyPlanLadder" + i + "Flow"] +
                "m³,价格:" +
                param.ladderData["standbyPlanLadder" + i + "Price"] / 100 +
                "元/m³";
            }
            param["standbyPlan"] = standbyPlan;
            return param;
          });
          that.dataCount = data.body.amount;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
      });
    },
    onWorkingFlowRechargeChange(param) {
      let totalRecordFlowParam = this.totalRecordFlow;
      let totalRecordMoneyParam = this.totalRecordMoney;
      param = param + totalRecordFlowParam;
      var rank = 5;
      var rankFlow = 0;
      var index = 1;
      while (index < 10) {
        rankFlow += this.ladderPriceRecent.paras[
          "mainPlanLadder" + index + "Flow"
        ];
        if (param <= rankFlow) {
          break;
        }
        index++;
      }
      if (Object.keys(this.ladderPriceRecent.paras) != 0) {
        this.workingFlowRechargeMoney =
          (this.flowToPrice(
            param *
              this.ladderPriceRecent.paras["mainPlanLadder" + index + "Price"],
            index - 1,
            this.ladderPriceRecent.paras["mainPlanLadder" + index + "Price"]
          ) -
            totalRecordMoneyParam * 100) /
          100;
        this.workingFlowRankPricePresent =
          this.ladderPriceRecent.paras["mainPlanLadder" + index + "Price"] /
          100;
        this.workingFlowRankRemain = rankFlow - param;
      }
    },
    flowToPrice(price, n, priceRank) {
      if (n > 0) {
        price =
          price -
          this.ladderPriceRecent.paras["mainPlanLadder" + n + "Flow"] *
            (priceRank -
              this.ladderPriceRecent.paras["mainPlanLadder" + n + "Price"]);
        n--;
        return this.flowToPrice(price, n, priceRank);
      } else {
        return price;
      }
    },
    commitRecharge() {
      if (Object.keys(this.ladderPriceRecent.paras) == 0) {
        this.$Notice.error({
          title: "异常",
          desc: "设备不包含阶梯气价！",
        });
      } else if (
        this.workingFlowRecharge * 1 == 0 &&
        this.workingMoneyRecharge * 1 == 0
      ) {
        this.$Notice.error({
          title: "异常",
          desc: "未充值！",
        });
      } else {
        this.doRecharge();
      }
    },
    doRecharge() {
      //充值
      var that = this;
      this.doRechargeData["recordRechargeMeterId"] = this.deviceTemp.meterId; //设备表号
      if (this.isFlow) {
        this.doRechargeData[
          "recordRechargePrice"
        ] = this.workingFlowRechargeMoney; //充值金额
        this.doRechargeData["recordRechargeFlow"] = this.workingFlowRecharge; //充值流量
      } else {
        this.doRechargeData["recordRechargePrice"] = this.workingMoneyRecharge; //充值金额
      }
      this.doRechargeData[
        "recordRechargePayType"
      ] = this.rechargeBaseInfo.meterTypePayType; //缴费类型
      this.doRechargeData["recordRechargeDate"] = new Date().getTime(); //充值时间
      this.doRechargeData[
        "recordRechargePresentLadderPrice"
      ] = this.workingFlowRankPricePresent; //当前阶梯气价
      this.doRechargeData[
        "recordRechargePresentLadderFlowRemain"
      ] = this.workingFlowRankRemain; //当前阶梯剩余流量
      this.doRechargeData["recordRechargeLadderPriceCopy"] = JSON.stringify(
        this.ladderPriceRecent
      ); //阶梯气价备份
      this.doRechargeData[
        "recordRechargeAddressName"
      ] = this.rechargeBaseInfo.addressLowestLevelAddressIds; //地址
      this.doRechargeData[
        "recordRechargeCustomerId"
      ] = this.rechargeBaseInfo.customerId; //用户ID
      this.doRechargeData[
        "recordRechargeCustomerName"
      ] = this.rechargeBaseInfo.customerName; //用户姓名
      this.doRechargeData[
        "recordRechargeCustomerIdcard"
      ] = this.rechargeBaseInfo.customerIdcard; //用户身份证
      this.isCommitSpin = true;
      $.ajax({
        url: "/api/recharge/doRecharge",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.doRechargeData),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            return;
          }
          that.$Notice.success({
            title: "成功",
            desc: "充值成功！",
          });
          that.$parent.step3to4(true);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
        complete: function() {
          that.isCommitSpin = false;
        },
      });
    },
  },
  components: {
    rechargeExpand,
  },
};
</script>
<style>
.spin-icon-load {
  animation: ani-spin 1s linear infinite;
}

@keyframes ani-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
